@if (tabs?.length) {
  <div class="tab-group">
    @if (indicatorContainer) {
      <ng-container *ngTemplateOutlet="indicatorContainer, context: { content: indicators }"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="indicators"></ng-container>
    }
    <div class="tab-contents">
      <ng-content select="app-tab"></ng-content>
    </div>
  </div>
}

<ng-template #indicators>
  <div class="tabs" [ngClass]="['justify-' + tabJustify, containerSize]">
    @for (tab of tabs; track tab) {
      <button
        class="tab"
        [class.active]="tab.active"
        (click)="setActiveTab(tab)"
        >
        {{ tab.label }}
      </button>
    }
  </div>
</ng-template>
